import React from 'react';
import { useRecordContext } from 'react-admin';
import { Grid, Box, Divider, Typography, styled } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { sectionTitleStyle, smallGrayFontStyle } from 'src/styles';
import { EducationCenterType } from 'src/components/Employees/types';

/**
 * Formats phone number string +380123456789 to +38 (012) 345-67-89
 * @param { string } phoneNumber
 * @returns { string }
 */
const getFormattedPhoneNumber = (phoneNumber: string): string => {
    const arrayLikePhoneNumber = phoneNumber.split('');

    return arrayLikePhoneNumber
        .map((character: string, i: number): string => {
            switch (i) {
                case 3:
                    return ` (${character}`;
                case 5:
                    return `${character}) `;
                case 9:
                case 11:
                    return `-${character}`;
                default:
                    return character;
            }
        })
        .join('');
};

const GeneralCenterInfoTab: React.FC = () => {
    const record = useRecordContext<EducationCenterType>();
    if (!record) return null;

    return (
        <Grid p={3} container columnSpacing={4} rowSpacing={1}>
            <Grid item xs={12}>
                <Box sx={{ ...sectionTitleStyle, mb: 3 }} whiteSpace="normal">
                    Контактна інформація
                </Box>
            </Grid>
            <Grid item xs={3}>
                <Box sx={smallGrayFontStyle} mb={1}>
                    Скорочена назва
                </Box>
                <Box mb={0.3}>{record.shortName}</Box>
            </Grid>
            <Grid item xs={3}>
                <Box sx={smallGrayFontStyle} mb={1}>
                    Контактний номер телефону
                </Box>
                <Box mb={0.3}>{getFormattedPhoneNumber(record.phone)}</Box>
            </Grid>
            <Grid item xs={3}>
                <Box sx={smallGrayFontStyle} mb={1}>
                    Адреса
                </Box>
                <Box mb={0.3}>{record.address}</Box>
            </Grid>
            <Grid item xs={12}>
                <Divider sx={{ mb: 2, mt: 2 }} />
            </Grid>
        </Grid>
    );
};

export default GeneralCenterInfoTab;
